import React from 'react'

import { IconProps } from './types'

const Plus: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    width={size}
    height={size}
    stroke={color}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path d="M4 8H12M8 4V12" />
  </svg>
)
Plus.defaultProps = {
  size: 16,
  color: 'currentColor',
}

export default Plus
